import { useContext } from 'react';

import AppContext from 'lane-shared/contexts/AppContext';

export function useWhitelabel() {
  const appContext = useContext(AppContext);

  const whitelabel = appContext.whitelabel;
  const isWhitelabelInitialized = Object.keys(whitelabel).length !== 0;

  if (!isWhitelabelInitialized) {
    throw new Error('Whitelabel has not been initialized in AppContext');
  }

  return whitelabel;
}
